import { useCompositionStatus } from './use-composition-status'

/** True while this creative's composition is still being fetched. Previews use it to hide the
 *  legacy "Ask AI / Change image" hover during the fetch: without it the old overlay paints for
 *  the length of the round-trip and is then replaced by the live canvas the instant the
 *  composition resolves, which reads as a flash of the old UI. */
export function useCompositionLoading(creativeId?: string | null): boolean {
  return useCompositionStatus(s => (creativeId ? s.byId[creativeId] === 'loading' : false))
}
